import { environment as baseEnvironment } from '@doger/core/shared/config';

export const environment = {
  ...baseEnvironment,
  clarity: {
    id: import.meta.env.CLARITY_ID,
  },
  amplitude: {
    apiKey: import.meta.env.AMPLITUDE_API_KEY,
    release: import.meta.env.SENTRY_RELEASE_COMMIT_SHA,
  },
};
